document.addEventListener('DOMContentLoaded', function() {
  // 1. Sticky CTA Logic
  const bar = document.querySelector('.sticky-cta');
  const authorMark = document.querySelector('.author-mark');
  const offer = document.querySelector('#offer');
  
  if (bar && authorMark && offer) {
    const show = () => bar.classList.toggle('is-active', authorMark.getBoundingClientRect().bottom < 0 && offer.getBoundingClientRect().top > window.innerHeight);
    window.addEventListener('scroll', show, { passive: true });
    show();
  }

  // 2. Smooth Scroll without URL change for Study Refs
  document.querySelectorAll('a.study-ref').forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault(); // Stops the URL from changing to #research
      const href = this.getAttribute('href');
      if (href && href !== '#') {
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });
});